<template>
  <v-container fluid py-4 px-0 ma-0>
    <PageHeader :title="user.displayName" subtitle="Edit user profile"></PageHeader>
    <v-container
      id="useredit-main"
      class="pa-0 px-4 ma-0 fluid">
     <v-flex style="background-color:white;" class="pa-0 elevation-2 rounded-3 ">
        <v-tabs class="useredit-tabs" show-arrows color="white" slider-color="primary" grow>
          <v-tab
            ripple v-for="item in items" :key="item.name"
            @click="handleClick(item)" :class="item.class">
            {{item.name}}
          </v-tab>
          <v-tab-item v-for="item in items" :key="item.name+'-content'">
            <v-divider></v-divider>
            <v-container fluid>
              <Loading :isLoading="currentUserLoading">
                <v-layout row wrap>
                  <v-flex xs12 px-4 py-3 mb-3>
                    <!-- Users Edit tab content -->
                    <div id="user edit details">
                      <component
                        v-on:userUpdate="toggleChangesMade()"
                        v-on:passUpdate="passwordChanged=true"
                        v-on:mfaUpdate="mfaChanged=true"
                        v-on:toggleMFA="toggleMFA()"                        
                        :configMode="true"
                        :is="item.component"/>
                    </div>
                  </v-flex>
                </v-layout>
              </Loading>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-dialog v-model="ShowSaveUserDialog" width="400" persistent id="useredit-save-dialog">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>Save User</h2>
          </v-card-title>
          <v-card-text class="pa-0">
            <p>Would you like to save these changes before continuing?</p>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn
              @click="updateUser()"
              class="useredit-save-dialog-save-btn"
              color="success">
              OK
            </v-btn>
            <v-btn
              class="useredit-save-dialog-cancel-btn"
              @click="cancelEdit()"
              color="error">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="ShowDeleteUserDialog" aria-label="useredit-delete-dialog" width="400">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>Delete User</h2>
          </v-card-title>
          <v-card-text class="pa-0">
            <p>Are you sure you want to delete this user?</p>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn
              @click="deleteUser"
              class="useredit-delete-dialog-delete-btn"
              color="error">
              Yes, delete this user
            </v-btn>
            <v-btn
              @click="ShowDeleteUserDialog = false"
              class="useredit-delete-dialog-cancel-btn"
              color="secondary">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-layout row wrap class="px-4">
      <v-btn
        class="delete-user-button useredit-delete-btn mt-4 ml-0"
        color="error" dark
        @click="ShowDeleteUserDialog = true"
        :disabled="currentUserLoading">
        <v-icon>delete</v-icon>&emsp;Delete user
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="save-user-button mt-4 mb-0 mx-0"
        color="success" dark
        :disabled="currentUserLoading"
        @click="ShowSaveUserDialog = true">
        Save Changes
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import PageHeader from "@/components/PageHeader.vue"
import UserEditDetails from "@/components/Users/UserEdit/UserEditDetails.vue"
import UserEditPassword from "@/components/Users/UserEdit/UserEditPassword.vue"
import UserEditMFA from "@/components/Users/UserEdit/UserEditMFA.vue"
import UserEditTeams from "@/components/Users/UserEdit/UserEditTeams.vue"
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "user-edit",
  components: {
    UserEditDetails,
    UserEditPassword,
    UserEditMFA,
    UserEditTeams,
    Loading,
    PageHeader
  },
  data: () => ({
    changesMade: false,
    passwordChanged: false,
    mfaChanged: false,
    mfaDisabled: false,    
    ShowSaveUserDialog: false,
    ShowDeleteUserDialog: false,
    tabModel: 0,
    localUpdate: false
  }),
  watch: {
    userId() { this.reload() },
    userTab() { this.handleRouteChange(this.userTab) }
  },
  computed: {
    ...mapState({
      userId: state => state.cbroute.params.id,
      userTab: state => state.cbroute.params.userTab,
      currentUserLoading: state => state.ui.loadingSelectedUser,
      user: state => state.users.currentlySelected.user,
      currentUser: state => state.currentUser,
      avatar: function() {
        return Helpers.isPresent(this.user.avatar_url)
          ? this.user.avatar_url
          : "https://login.caseblocks.com/assets/ea_icon_user_sm.png"
      }
    }),
    items() {
      return [{ name: "Teams", title: "User Teams", component: "UserEditTeams", class: "teams-tab" },
        { name: "Profile", title: "User Profile", component: "UserEditDetails", class: "profile-tab" },
        { name: "Password", title: "User Password", component: "UserEditPassword", class: "password-tab" },
        { name: "MFA", title: "Multifactor Authentication", component: "UserEditMFA", class: "mfa-tab" }

      ]
    }
  },
  methods: {
    toggleMFA() {
      this.mfaDisabled = !this.mfaDisabled
    },    
    toggleChangesMade() {
      this.changesMade=true
    },    
    reload() {
      this.$store.dispatch('setCurrentlySelectedUser', parseInt(this.userId))
    },
    checkSaveDialog() {
      this.ShowSaveUserDialog = this.changesMade || this.mfaChanged || this.mfaDisabled
    },
    handleClick(item) {
      this.localUpdate = true
      this.$router.push({ path: item.name })
    },
    handleRouteChange(route) {
      if (!this.localUpdate) {
        switch (route) {
          case "password":
            this.tabModel = 1
            break
          case "teams":
            this.tabModel = 2
            break
          case "preferences":
            this.tabModel = 3
            break
          default:
            this.tabModel = 0
        }
      }
      this.localUpdate = false
    },
    async deleteUser() {
      this.ShowDeleteUserDialog = false
      const deleted = await this.$store.dispatch("deleteUser", this.user)
      if (deleted) {
        this.$router.push({ name: "Users" })
      }
    },
    async updateUser() {
      this.ShowSaveUserDialog = false
      let result = { error: false }

      if (this.mfaChanged) {
        result = await this.$store.dispatch("setupMFA", this.user)
      }

      if (this.mfaDisabled) {
        result = await this.$store.dispatch("disableMFA", this.user)
      }      

      if (!result.error && this.passwordChanged) {
        result = await this.$store.dispatch("updateUserWithPassword", this.user)
      } else if (!result.error && this.changesMade) {
        result = await this.$store.dispatch("updateUser", this.user)
      }
      if (!result.error) {
        this.passwordChanged = false
        this.changesMade = false
        this.mfaChanged = false
        this.$router.push({ name: "Users" })
      }
    },
    cancelEdit() {
      this.changesMade = false
      this.ShowSaveUserDialog = false
      this.$router.push({ name: "Users" })
    },
    returnToHome() {
      this.$router.push({ name: "Dashboard", params: { section: 'overview' } })
    }
  }
}
</script>
